function getDomainPathFromPathReduxUtil (path = '') {
  if (!path.indexOf('.')) {
    return path
  }
  return path.slice(0, path.indexOf('.'))
}

export default getDomainPathFromPathReduxUtil
